
import Util from "./Util"

let viewCache = {};
let clickEvents = {};
let viewEvents = {};

// https://plainjs.com/javascript/events/live-binding-event-handlers-14/

const addEvent = (el, type, handler) => {
  if (el.attachEvent) el.attachEvent('on'+type, handler); else el.addEventListener(type, handler);
}

// live binding helper using matchesSelector
const on = (selector, event, callback, context) => {
  addEvent(context || document, event, function(e) {
    var found, el = e.target || e.srcElement;
    while (el && el.matches && el !== context && !(found = el.matches(selector))) el = el.parentElement;
    if (found) callback.call(el, e);
  });
}

const sendEvent = (gtmData) => {
  const dataLayer = window.dataLayer || [];
  if (typeof(dataLayer.push) != "undefined" && dataLayer.push instanceof Function) {
    // console.log('event,ec,ea,el', event, ec, ea,el)
    dataLayer.push(gtmData);
    console.log('GTM ', gtmData)
  }
};

const trackClick = (key, props) => {
  if (props.length < 2) return;
  on(key, 'click', function(){ 
    const ec = props[0]; // Event Category
    const el = props[1]; // Event Element
    const gtmData = {
      event: 'Transition Event',
      ec: ec,
      ea: 'click',
      el: el
    }
    sendEvent(gtmData)
  });
}

const trackView = (key, props) => {
  if (props.length < 2) return;
  var el = document.querySelector(key);
  if (!el) return;
  if (Util.isScrolledIntoView(el) && !viewCache[key]) {
    viewCache[key] = true;    
    const ec = props[0]; // Event Category
    const el = props[1]; // Event Element
    const gtmData = {
      event: 'Element View',
      ec: ec,
      ea: 'view',
      el: el,
      noninteraction: true
    }
    sendEvent(gtmData)
  }
}

const trackViewEvents = () => {
  for(var key in viewEvents) {
    trackView(key, viewEvents[key]) 
  }
  /*if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight) {
    if (!viewCache['footer']) {
      viewCache['footer'] = true;
      console.log('Track View:', 'footer')
    }
  }*/
}

const init = (trackingEvents) => {
  console.log('trackingEvents', trackingEvents)

  clickEvents = trackingEvents.clickEvents;
  viewEvents = trackingEvents.viewEvents;

  // track click events
  for (var key in clickEvents) {
    trackClick(key, clickEvents[key])    
  }

  // track view events   
  window.addEventListener('scroll', trackViewEvents)
  setTimeout(trackViewEvents, 0)

}

export default { init, sendEvent } 
